import * as yup from 'yup';
import AnimalType from '../../../../../enums/animal-type';

export const Option = yup.object().shape({
  value: yup.string().required(),
});

export const OptionNulable = yup.object().shape({
  value: yup.string().nullable(),
});

const warehouseSchema = yup.object().shape({
  animal_event_product_id: yup.string().nullable(),
  barn_id: Option,
  product_amount_for_one: yup.object().shape({
    amount: yup.string().nullable(),
    unit: OptionNulable,
  }),
  product_amount_total: yup.string().required(),
  product_unit: Option,
  amount_for_one: yup.string().nullable(),
  amount_for_one_unit: Option,
});

const productSchema = yup.object().shape({
  product_category_id: Option,
  product_type_id: Option,
  product_id: Option,
  barns: yup.array().of(warehouseSchema),
});

const nullableDateWhenPregnancy = yup.mixed().when('event_type', {
  is: (value) => value === AnimalType.dry_off,
  then: yup.string().nullable(),
  otherwise: yup.mixed(),
});

export const schema = yup.object().shape({
  event_type: yup.string().required(),
  species: OptionNulable,
  barn_ldc_nr: OptionNulable,
  animal_id: OptionNulable,
  status: yup.string().required(),
  date: yup.date().required(),
  medicines_status: yup.string().required(),
  birth_weight: yup.mixed().when('event_type', {
    is: (value) => value !== AnimalType.dry_off,
    then: yup.number().required(),
    otherwise: yup.mixed(),
  }),
  recorded_weight: yup.mixed().when('event_type', {
    is: (value) => value !== AnimalType.dry_off,
    then: yup.number().required(),
    otherwise: yup.mixed(),
  }),

  growth: yup.string().nullable(),

  products: yup.mixed().when('event_type', {
    is: (value) => value === AnimalType.dry_off,
    then: yup.mixed().when('medicines_status', {
      is: (value) => !!Number(value),
      then: yup.array().of(productSchema),
      otherwise: yup.mixed(),
    }),
    otherwise: yup.mixed(),
  }),
  meat_restrictions_date_from: nullableDateWhenPregnancy,
  meat_restrictions_date_to: nullableDateWhenPregnancy,
  milk_restrictions_date_from: nullableDateWhenPregnancy,
  milk_restrictions_date_to: nullableDateWhenPregnancy,
  meat_days: yup.string().nullable(),
  milk_days: yup.string().nullable(),
  notes: yup.string().max(4000).nullable(),
  file: yup.mixed(),
});
